import UIPanel from 'UIComponents/panel/UIPanel';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import { useState } from 'react';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelLoadingComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(UIPanel, {
    children: [/*#__PURE__*/_jsxs(UIPanelHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.loadingModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      })
    }), /*#__PURE__*/_jsx(UIPanelFooter, {})]
  });
};
export const DefaultLoadingComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.loadingModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {})]
  });
};
export const DefaultErrorComponent = () => {
  const [isMounted, setIsMounted] = useState(true);
  if (!isMounted) {
    return null;
  }
  const close = () => setIsMounted(false);
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: close
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "bulkActions.modals.errorModal.title"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        type: "badRequest"
      })
    })]
  });
};
export const makeCodeSplitModal = ({
  importResult,
  LoadingComponent = DefaultLoadingComponent,
  ErrorComponent = DefaultErrorComponent
}) => Loadable({
  loader: importResult,
  LoadingComponent,
  ErrorComponent
});